import { Box, Button, CircularProgress } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { setActiveCarSellStep } from "../../../toolkit/sellMyCar/sellMyCarSlice";
import { SellMyCarSteps } from "../../../utils/constants/sellMyCar";
import { useTranslation } from "react-i18next";

const NavigationButtons = ({ 
  onSubmit,
  isLoading,
  previousFormHandler
}) => {

  const { t } = useTranslation("sellMyCar");

  const dispatch = useDispatch();
  const { activeCarSellStep } = useSelector(
    (state) => state.sellMyCarDashboard
  );

  const activeIndex = SellMyCarSteps.indexOf(activeCarSellStep);

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        gap: "1rem",
        marginTop: "2rem",
      }}
    >
      <Button
        variant="outlined"
        sx={{ borderRadius: "0.5rem", padding: "0.5rem 1.5rem" }}
        onClick={() => {
          // if (activeIndex > 0) {
          //   dispatch(setActiveCarSellStep(SellMyCarSteps[activeIndex - 1]));
          // }
          if (previousFormHandler) {
            previousFormHandler();
          }
        }}
      >
        {t("Back")}
      </Button>
      <Button
        type="submit"
        variant="contained"
        color="primary"
        sx={{ borderRadius: "0.5rem", padding: "0.5rem 1.5rem" }}
        // onClick={() => {
        //   if (onSubmit) {
        //     onSubmit();
        //   }
        //   // if (activeIndex < SellMyCarSteps.length - 1) {
        //   //   dispatch(
        //   //     setActiveCarSellStep(SellMyCarSteps[activeIndex + 1])
        //   //   );
        //   // }
        // }}
        disabled={isLoading}
      >
        {isLoading ? (
          <CircularProgress size={22} />
        ) : (
          t("Continue")
        )}
      </Button>
    </Box>
  );
};

export default NavigationButtons;
